'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import classNames from 'classnames'
import Image from 'next/image'

enum Nav {
  OVERVIEW = 'Overview',
  SPOT = 'Spot',
  DEPOSIT = 'Deposit',
  WITHDRAW = 'Withdraw',
  FUTURES = 'Futures',
  TRANSACTION_HISTORY = 'Transaction History',
  COE_TOKEN = 'COE Token',
}

export default function SideNav() {
  const path = usePathname()
  const locale = path.split('/')[1]
  const midNav = path.split('/')[3]
  const lastNav: string | undefined = path.split('/')[4] // spot 하위 - deposit, withdraw

  console.log(midNav, Nav.OVERVIEW)

  return (
    <nav className='relative flex flex-col pt-6 text-left text-base font-medium leading-[18px] tracking-[-0.02em]'>
      <Link href={`/${locale}/wallet/overview`} className='flex w-full flex-col pb-2'>
        <div
          className={classNames('flex w-[272px] items-center gap-2 px-6 py-3', {
            'rounded-r-[8px] bg-light-gray-01': midNav === 'overview',
          })}
        >
          <div className='flex items-center gap-2'>
            <Image src={'/icon_home_light.svg'} alt='spot order' width={20} height={20} hidden={midNav !== 'overview'} />
            <Image src={'/icon_home_light_inactive.svg'} alt='spot order' width={20} height={20} hidden={midNav === 'overview'} />
            <span
              className={classNames('', {
                'text-light-font-01': midNav === 'overview',
                'text-dark-font-02': midNav !== 'overview',
              })}
            >
              {Nav.OVERVIEW}
            </span>
          </div>
        </div>
      </Link>
      <Link href={`/${locale}/wallet/spot`} className='flex w-full flex-col pb-2'>
        <div
          className={classNames('flex w-[272px] items-center gap-2 px-6 py-3', {
            'rounded-r-[8px] bg-light-gray-01': midNav === 'spot' && !lastNav,
          })}
        >
          <div className='flex items-center gap-2'>
            <Image src={'/icon_nav_orders_spot.svg'} alt='spot order' width={20} height={20} hidden={midNav !== 'spot'} />
            <Image src={'/icon_nav_orders_spot_inactive.svg'} alt='spot order' width={20} height={20} hidden={midNav === 'spot'} />
            <span
              className={classNames('', {
                'text-light-font-01': midNav === 'spot',
                'text-dark-font-02': midNav !== 'spot',
              })}
            >
              {Nav.SPOT}
            </span>
          </div>
        </div>
      </Link>
      {
        // spot 하위 - deposit, withdraw
        midNav === 'spot' && (
          <>
            <Link href={`/${locale}/wallet/spot/deposit`} className='flex w-full flex-col pb-2'>
              <div
                className={classNames('flex w-[272px] items-center gap-2 px-[52px] py-3', {
                  'rounded-r-[8px] bg-light-gray-01': midNav === 'spot' && lastNav === 'deposit',
                })}
              >
                <div className='flex items-center gap-2'>
                  <span
                    className={classNames('', {
                      'text-light-font-01': midNav === 'spot' && lastNav === 'deposit',
                      'text-dark-font-02': midNav === 'spot' && lastNav !== 'deposit',
                    })}
                  >
                    {Nav.DEPOSIT}
                  </span>
                </div>
              </div>
            </Link>
            <Link href={`/${locale}/wallet/spot/withdraw`} className='flex w-full flex-col pb-2'>
              <div
                className={classNames('flex w-[272px] items-center gap-2 px-[52px] py-3', {
                  'rounded-r-[8px] bg-light-gray-01': midNav === 'spot' && lastNav === 'withdraw',
                })}
              >
                <div className='flex items-center gap-2'>
                  <span
                    className={classNames('', {
                      'text-light-font-01': midNav === 'spot' && lastNav === 'withdraw',
                      'text-dark-font-02': midNav === 'spot' && lastNav !== 'withdraw',
                    })}
                  >
                    {Nav.WITHDRAW}
                  </span>
                </div>
              </div>
            </Link>
          </>
        )
      }
      <Link href={`/${locale}/wallet/futures`} className='flex w-full flex-col pb-2'>
        <div
          className={classNames('flex w-[272px] items-center gap-2 px-6 py-3', {
            'rounded-r-[8px] bg-light-gray-01': midNav === 'futures',
          })}
        >
          <div className='flex items-center gap-2'>
            <Image src={'/icon_nav_orders_futures.svg'} alt='spot order' width={20} height={20} hidden={midNav !== 'futures'} />
            <Image src={'/icon_nav_orders_futures_inactive.svg'} alt='spot order' width={20} height={20} hidden={midNav === 'futures'} />
            <span
              className={classNames('', {
                'text-light-font-01': midNav === 'futures',
                'text-dark-font-02': midNav !== 'futures',
              })}
            >
              {Nav.FUTURES}
            </span>
          </div>
        </div>
      </Link>
      <Link href={`/${locale}/wallet/transaction-history`} className='flex w-full flex-col pb-2'>
        <div
          className={classNames('flex w-[272px] items-center gap-2 px-6 py-3', {
            'rounded-r-[8px] bg-light-gray-01': midNav === 'transaction-history',
          })}
        >
          <div className='flex items-center gap-2'>
            <Image src={'/icon_clock_light.svg'} alt='spot order' width={20} height={20} hidden={midNav !== 'transaction-history'} />
            <Image src={'/icon_clock_light_inactive.svg'} alt='spot order' width={20} height={20} hidden={midNav === 'transaction-history'} />
            <span
              className={classNames('', {
                'text-light-font-01': midNav === 'transaction-history',
                'text-dark-font-02': midNav !== 'transaction-history',
              })}
            >
              {Nav.TRANSACTION_HISTORY}
            </span>
          </div>
        </div>
      </Link>
      {/* <Link
        href={`/${locale}/wallet/coe-token`}
        className="flex w-full flex-col pb-2"
      >
        <div
          className={classNames("w-[272px] flex items-center gap-2 px-6 py-3", {
            "bg-light-gray-01 rounded-r-[8px]": midNav === "coe-token",
          })}
        >
          <div className="flex items-center gap-2">
            <Image
              src={
                midNav === "coe-token"
                  ? "/icon_rank_light.svg"
                  : "/icon_rank_light_inactive.svg"
              }
              alt="spot order"
              width={20}
              height={20}
            />
            <span
              className={classNames("", {
                "text-light-font-01": midNav === "coe-token",
                "text-dark-font-02": midNav !== "coe-token",
              })}
            >
              {Nav.COE_TOKEN}
            </span>
          </div>
        </div>
      </Link> */}
    </nav>
  )
}
